export * from './ThingNameForm';
export { ThingNameForm as default } from './ThingNameForm';
